import {
    Switch as ChakraSwitch,
    type SystemStyleObject,
} from "@chakra-ui/react";
import * as React from "react";

export interface SwitchProps extends ChakraSwitch.RootProps {
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    rootRef?: React.Ref<HTMLLabelElement>;
    trackLabel?: { on: React.ReactNode; off: React.ReactNode };
    thumbLabel?: { on: React.ReactNode; off: React.ReactNode };
    controlCheckedProps?: SystemStyleObject;
    thumbCheckedProps?: SystemStyleObject;
}

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
    (props, ref) => {
        const {
            inputProps,
            children,
            rootRef,
            trackLabel,
            thumbLabel,
            controlCheckedProps,
            thumbCheckedProps,
            ...rest
        } = props;

        return (
            <ChakraSwitch.Root ref={rootRef} {...rest}>
                <ChakraSwitch.HiddenInput ref={ref} {...inputProps} />
                <ChakraSwitch.Control _checked={controlCheckedProps}>
                    <ChakraSwitch.Thumb _checked={thumbCheckedProps}>
                        {thumbLabel && (
                            <ChakraSwitch.ThumbIndicator
                                fallback={thumbLabel?.off}
                            >
                                {thumbLabel?.on}
                            </ChakraSwitch.ThumbIndicator>
                        )}
                    </ChakraSwitch.Thumb>
                    {trackLabel && (
                        <ChakraSwitch.Indicator fallback={trackLabel.off}>
                            {trackLabel.on}
                        </ChakraSwitch.Indicator>
                    )}
                </ChakraSwitch.Control>
                {children != null && (
                    <ChakraSwitch.Label>{children}</ChakraSwitch.Label>
                )}
            </ChakraSwitch.Root>
        );
    },
);
